<template>
  <div class="bindQualityTracingCode">
    <div class="content-container">
      <div class="titieMian">
        <div class="title-container">绑定溯源码</div>
        <div class="form-container">
          <div class="top">
            <div class="item">
              <p class="name"><font style="opacity: 0">累了</font>溯源主码：</p>
              <p class="name">{{ code }}</p>
            </div>
            <div class="item">
              <p class="name">溯源码起始号：</p>
              <div class="start-input">
                <input
                  type="text"
                  disabled
                  v-model="traceEnterNum"
                  class="start-input-item"
                />
                <span class="line"></span>
                <input
                  type="text"
                  onkeyup="value=value.replace(/[^\d\s.]/g,'')"
                  v-model="startNum"
                  maxlength="8"
                  :disabled="!edit"
                  class="start-input-item end-input-item"
                />
              </div>
              <span class="line"></span>
              <div class="start-input">
                <input
                  type="text"
                  disabled
                  v-model="traceEnterNum"
                  class="start-input-item"
                />
                <span class="line"></span>
                <input
                  type="text"
                  onkeyup="value=value.replace(/[^\d\s.]/g,'')"
                  v-model="endNum"
                  maxlength="8"
                  :disabled="!edit"
                  class="start-input-item end-input-item"
                />
              </div>
              <button class="bind-btn" v-if="edit" @click="bindBumber">绑定</button>
            </div>
          </div>
          <div class="list">
            <div class="item" v-for="(item, index) of list" :key="index">
              <p>{{ index + 1 }}</p>
              <input
                type="text"
                disabled="disabled"
                class="cardInput"
                :value="item"
              />
              <div class="icon">
                <img
                  src="../../../assets/images/icon_upload_successful.png"
                  alt=""
                />
              </div>
              <div class="icon" v-if="edit" @click="det(item, index)">
                <img
                  src="../../../assets/images/icon_upload_failure.png"
                  alt=""
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import mixins from "@/common/MixIn.js";
export default {
  name: "BindqualityTracingCode",
  mixins: [mixins],
  data() {
    return {
      startNum: null,
      endNum: null,
      list: [],
      code: "",
      traceEnterNum: null
    };
  },
  watch: {
    startNum: function(val) {
      this.startNum = val.replace(/\D/g, "");
    },
    endNum: function(val) {
      this.endNum = val.replace(/\D/g, "");
    }
  },
  methods: {
    // getCompanyName
    getCompanyName() {
      this.$api.getCompanyName().then(res => {
        this.traceEnterNum = 94024671;
      });
    },
    // 绑定
    bindBumber() {
      let startNum = Number(this.startNum);
      let endNum = Number(this.endNum);
      let val = endNum - startNum;
      let list = [];
      if (!startNum || !endNum) {
        this.$Alert.info({
          content: "起始号范围不能为空",
          duration: 3000,
          status: "error"
        });
        return false;
      } else if (startNum > endNum) {
        this.$Alert.info({
          content: "起始号初始值不能大于结束值",
          duration: 3000,
          status: "error"
        });
        return false;
      } else if (val > 50) {
        this.$Alert.info({
          content: "起始号范围不能大于50",
          duration: 3000,
          status: "error"
        });
        return false;
      } else if (this.startNum.length < 8 || this.endNum.length < 8) {
        this.$Alert.info({
          content: "起始范围和结束范围必须是八位数",
          duration: 3000,
          status: "error"
        });
        return false;
      }
      for (let i = 0; i <= val; i++) {
        let start = String(this.traceEnterNum) + String(this.startNum);
        console.log(start)
        list.push(Number(start) + Number(i));
      }
      console.log(list);
      let params = {
        code: this.code,
        SubcodeList: list
      };
      const h = this.$createElement;
      this.$msgbox({
        title: "消息",
        message: h("div", null, [
          h("p", null, "确定绑定当前范围编码吗？"),
          h(
            "p",
            { style: "color: red" },
            `编号范围：（${String(this.startNum)} - ${String(this.endNum)}）`
          )
        ]),
        showCancelButton: true,
        confirmButtonText: "确定",
        cancelButtonText: "取消"
      }).then(action => {
        this.$api
          .bindQualityTracingCode(params)
          .then(res => {
            if (res.data === "") {
              this.$message({
                message: "绑定成功",
                type: "success"
              });
              this.list = list;
            }
          })
          .catch(err => {
            this.$Alert.info({
              content: err.response.data,
              duration: 5000,
              status: "error"
            });
          });
      });
    },
    async det(code, index) {
      this.$msgbox
        .confirm("此操作将删除该条记录，是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
        .then(async () => {
          this.list.splice(index, 1);
          this.$api.deleteSubordCode(code).then(res => {
            this.$Alert.info({
              content: "删除成功",
              duration: 1000,
              status: "success"
            });
          });
        });
    }
  },
  async mounted() {
    await this.initPagePermission();
    let code = this.$route.query.code;
    this.code = code;
    this.getCompanyName();
  }
};
</script>

<style lang="stylus" scoped>
.bindQualityTracingCode {
  .content-container {
    .form-container {
      width: 100%;
      height: auto;
      background: #fff;
      margin-top: -5px;
      padding: 20px 0 20px 0px;

      .top {
        padding-left: 259px;
        margin-bottom: 20px;

        .item {
          display: flex;
          align-items: center;
          margin-top: 14px;

          .name {
            font-size: 24px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #666;
            position: relative;
          }

          .start-input {
            width: 340px;
            height: 48px;
            background: #fff;
            border: 1px solid #d3d3d3;
            border-radius: 4px;
            padding: 0px 10px;
            text-align: center;
            display: flex;
            align-items: center;
            input {
              font-size: 30px;  
            }
            .start-input-item {
              width: 40%;
              outline: none;
              background: none;
              color: #cdcdcd;   
              transform: scale(1.12);
              margin-left: 5px;
              margin-top: 3px;     
            }

            .end-input-item {
              color: #25323f;
              font-weight: bold; 
              margin-left: 0px;     
            }

            span {
              margin: 0 20px;
              width: 20px;
              height: 1px;
              background: #25323f;
            }
          }

          span {
            margin: 0 20px;
            width: 20px;
            height: 1px;
            background: #25323f;
          }

          .bind-btn {
            width: 96px;
            height: 48px;
            background: #3897FF;
            border: 1px solid #3897FF;
            border: 0;
            font-size: 20px;
            color: #fff;
            border-radius: 4px;
            margin-left: 25px;
          }
        }
      }

      .list {
        display: flex;
        flex-direction: column;
        .item {
          width: 100%;
          height: 64px;
          background: #fff;
          display: flex;
          align-items: center;
          justify-content: center;
          &:nth-child(odd) {
            background: #f2f9ff;
          }
          p {
            font-size: 24px;
            font-family: Microsoft YaHei UI;
            font-weight: 400;
            color: #666;
            text-align: center;
            width: 30px;
          }

          .cardInput {
            // flex: 1;
            height: 80px;
            background: none;
            border: none;
            border-radius: 4px;
            font-size: 28px;
            font-family: Microsoft YaHei UI;
            font-weight: bold;
            color: #202b36;
            text-align: center;
          }

          .icon {
            width: 37px;
            height: 37px;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-right: 9px;
          }
          
        }
      }
    }
  }
}
</style>
